import {
  GeoJsonFeature,
  GeoJsonLineString,
  GeoJsonMultiLineString
} from '@/interfaces/misc.interface'
import { Placement } from '@/interfaces/poi.interface'
import { getRequestGateway } from '@/services/api.service'

export type LineCategoryDto = {
  id: string
  name: string
  types: LineTypeDto[]
  placement?: Placement
  createdBy: string
  createdDate: string
  lastModifiedBy: string
  lastModifiedDate: string
}
export type LineTypeDto = {
  id: string
  name: string
  color: string
}
export type Line = {
  disabled: boolean
  id: string
  name: string
  types: Line[]
  visible: boolean
}
export type LineDto = {
  id: string
  realmId: string
  createdBy: string
  createdDate: string
  lastModifiedBy: string
  lastModifiedDate: string
  categoryId: string
  coreId: string
  status: 'ACTIVE' | 'ARCHIVED'
  geometry: LineLayerDto
}
export type LineLayerDto = {
  name?: string
  typeId: string
  geometry: { coordinates: [number, number][]; type: 'LineString' }
  width?: number
}
export type LineLayer = {
  categoryId: string
  coreId: string
  geometry: GeoJsonLineString
  id: string
  length?: number
  name?: string
  realmId: string
  typeId: string
  width?: number
}
export async function getLineCategories(id: string) {
  return await getRequestGateway(`/zone/v1/line-categories?coreId=${id}&page=0&pageSize=100`)
}

export type LineGeoJsonProperties = {
  categoryId: string
  color: string
  id: string
  layerId?: string
  lineId: string // use this to identify the line, other id is BE specific it seems
  name: string
  typeId: string
  width?: number
}
export type LineGeoJsonFeature = GeoJsonFeature<
  GeoJsonLineString | GeoJsonMultiLineString,
  LineGeoJsonProperties
>

export async function getLineTypeFeatures(
  coreId: string,
  categoryId: string,
  typeId: string
): Promise<LineGeoJsonFeature[] | undefined> {
  const endpoint = `/zone/v1/lines/geojson?coreId=${coreId}&categoryId=${categoryId}&typeId=${typeId}&page=0&pageSize=100`
  try {
    const response = await getRequestGateway<LineGeoJsonFeature[]>(endpoint)
    return response?.data
  } catch (error) {
    return undefined
  }
}

export async function getLineType(typeId: string) {
  return await getRequestGateway(`/zone/v1/lines/${typeId})`)
}

/*
export async function getLineSummaryForLevel(levelId: string) {
  const endpoint = `/zone/v1/lines/summary/${levelId}`
  try {
    const response = await getRequestGateway(endpoint)
    if (response) return response.data
  } catch (e) {}
}
*/

export async function getLineSummaryForRealEstate(realEstateId: string): Promise<any> {
  const endpoint = `/zone/v1/lines/summary/${realEstateId}`
  try {
    const response = await getRequestGateway(endpoint)
    if (response) return response.data
  } catch (e) {}
}

export async function getLineById(id: string): Promise<LineDto | undefined> {
  const endpoint = `/zone/v1/lines/${id}`
  try {
    const response = await getRequestGateway<LineDto>(endpoint)
    if (response) return response.data
  } catch (e) {}
}

export async function getLineLayerById(id: string): Promise<LineLayer | undefined> {
  const endpoint = `/zone/v1/lines/layer/${id}`
  try {
    const response = await getRequestGateway<LineLayer>(endpoint)
    if (response) return response.data
  } catch (e) {
    return undefined
  }
}
